<template>
  <div class="progress-container">
    <div v-if="type === 'linear'" class="progress">
      <div
        v-if="value !== null && value >= 0"
        class="progress-bar"
        role="progressbar"
        :style="{width: `${value}%`}"
        :aria-valuenow="value"
        aria-valuemin="0"
        aria-valuemax="100"
      />

      <div v-else role="progressbar" class="progress-bar-indeterminate" />
    </div>

    <div v-else class="progress-spinner">
      <div
        :style="{maxWidth: `${this.size}px`, margin: '0 auto'}"
        ref="spinner"
        class="spinner"
      />
    </div>
  </div>
</template>

<script>
import lottie from 'lottie-web'
import animationBlack from './animation.json'
import animationWhite from './animation-white.json'

export default {
  props: {
    /**
     * The current value of progress value.
     */
    value: {
      type: Number,
      default: undefined,
      validator: (value) => value >= 0 && value <= 100,
    },

    /**
     * The type of progress to render.
     */
    type: {
      type: String,
      default: 'linear',
      validator: (value) => ['linear', 'spinner'].indexOf(value) !== -1,
    },

    size: {
      type: [String, Number],
      default: 32,
    },

    white: {
      type: Boolean,
      default: false,
    },
  },

  mounted() {
    if (this.type === 'spinner') {
      lottie.loadAnimation({
        renderer: 'svg',
        container: this.$refs['spinner'],
        animationData: this.white ? animationWhite : animationBlack,
        loop: true,
      })
    }
  },
}
</script>

<style lang="scss" scoped>
$enable-transitions: false;
$progress-height: 2px;
$progress-bg: $cyan-300;
$progress-bar-bg: $cyan-500;
$progress-border-radius: 0;
$progress-box-shadow: none;

@import '~bootstrap/scss/progress';

.progress {
  position: relative;

  &-container {
    position: relative;
    display: flex;
    flex-direction: column;
    min-width: 0;
  }

  &-bar-indeterminate {
    background-color: $progress-bar-bg;

    &:before {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      content: '';
      background-color: inherit;
      animation: indeterminate 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395)
        infinite;
      will-change: left, right;
    }

    &:after {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      content: '';
      background-color: inherit;
      animation: indeterminate 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) infinite;
      animation-delay: 1.15s;
      will-change: left, right;
    }
  }

  &-spinner {
    // height: 1rem;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    svg {
      fill: currentColor;
    }

    .spinner {
      max-width: 3rem;
    }
  }
}

@keyframes indeterminate {
  0% {
    right: 100%;
    left: -35%;
  }

  60% {
    right: -90%;
    left: 100%;
  }

  100% {
    right: -90%;
    left: 100%;
  }
}
</style>
